import { Checkbox } from "@mui/material";
import BasicSelect from "components/BasicInputs/BasicSelect";
import ConditionalTextInput from "components/Shared/ConditionalTextInput";
import { useEffect, useState } from "react";

export interface ChangeProps {
  plans?: Plan[];
  submit?: boolean;
  onsubmit: (state: ChangePricesState,fromSpeed?:boolean) => void;
}

export interface ChangePricesState {
  round?: boolean;
  roundDir?: "up" | "down";
  roundAcc?: number;
  plan?: Plan;
  amount?: number;
  dir?: "inc" | "dec";
  type?: "percent" | "currency";
}
export default function Change({ submit, onsubmit, plans: P }: ChangeProps) {
  const [state, setState] = useState<ChangePricesState>({
    round: false,
    roundDir: "up",
    roundAcc: 3,
    dir: "inc",
    type: "percent",
  });

  useEffect(() => {
    if (submit) onsubmit(state,true);
  }, [submit]);

  const plans = P || [];
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 24 }}>
      <BasicSelect
        label="اعمال بر لیست"
        options={plans.map((x) => ({ label: x.title, value: x.ind }))}
        onChange={(val) => {
          setState((x: any) => ({ ...x, plan: plans.find((y) => y.ind === val) }));
        }}
        noVirtual
      />
      <ConditionalTextInput
        onChange={(fd) => setState((x: any) => ({ ...x, amount: fd.value, dir: fd.first, type: fd.second }))}
        def={{
          first: state.dir,
          second: state.type,
          value: state.amount,
        }}
      />
      <div>
        <Checkbox checked={state.round} onChange={() => setState((x: any) => ({ ...x, round: !x.round }))} />
        <span>گرد کردن</span>
      </div>
      {state.round && (
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <BasicSelect
            options={[
              { label: "رو به پایین", value: "down" },
              { label: "رو به بالا", value: "up" },
            ]}
            defaultValue={state.roundDir}
            label="جهت گرد کردن"
            onChange={(val) => setState((x: any) => ({ ...x, roundDir: val }))}
            noVirtual
          />
          <BasicSelect
            options={[
              { label: "یک رقم اعشار", value: 1 },
              { label: "دو رقم اعشار", value: 2 },
              { label: "سه رقم اعشار", value: 3 },
            ]}
            defaultValue={state.roundAcc}
            label="دقت گرد کردن"
            onChange={(val) => setState((x: any) => ({ ...x, roundAcc: val }))}
            noVirtual
          />
        </div>
      )}
    </div>
  );
}
